import axios from 'axios';

const instance = axios.create({
	// baseURL: 'http://localhost:3501', // the api (cloud funcition) url
	baseURL: 'https://dev-donation-server.herokuapp.com/', // the api (cloud funcition) url
});

export default instance;
